import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js'; // Importa el contexto

const ProtectedRoute = ({ children, allowedRoles, allowedUsers }) => {
  const { isAuthenticated, user } = useContext(LoginContext);

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/" />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const rol = String(user?.tiu_descripcion || "").trim();
    if (!allowedRoles.includes(rol)) {
      return <Navigate to="/" />;
    }
  }

  if (Array.isArray(allowedUsers) && allowedUsers.length > 0) {
    const username = String(user?.usu_usuario || "").trim().toLowerCase();
    const allowed = allowedUsers.map((u) => String(u).trim().toLowerCase());
    if (!allowed.includes(username)) {
      return <Navigate to="/home-administrador" />;
    }
  }

  // Si está autenticado, renderiza los componentes hijos
  return children;
};

export default ProtectedRoute;
